module.exports = __webpack_public_path__ + "img/card_default.3ef19fb4.png";